import React, { createContext, useContext, useState, useCallback } from 'react';

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openQuote = useCallback((defaults = {}) => {
    setPrefill(defaults);
    setOpen(true);
  }, []);

  const closeQuote = useCallback(() => {
    setOpen(false);
    setPrefill({});
  }, []);

  return (
    <QuoteContext.Provider value={{ isOpen, prefill, openQuote, closeQuote }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error('useQuote must be used within QuoteProvider');
  return ctx;
};
